// Generated by CoffeeScript 2.7.0
var MoveTagModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

export default MoveTagModal = Vue.extend({
  components: {
    'modal': Modal,
    'Popover': Popover
  },
  props: {
    rejectTagGroup: {
      type: Object
    },
    doRequestUrl: {
      type: String
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      tagGroups: [],
      selectedTagGroup: null,
      valid: true
    };
  },
  template: `<modal title="标签移动"
       extendClass="tag-group-modal move-tag-modal"
       @ensureClicked="ensureClicked"
       size='small'
       ref="tagModalRef">
  <template>
    <div class="modal-body mt-5" >
      <div class="form-field required" :class="{ 'has-error': !valid }">
        <div class="form-field-head">
          <div class="form-field-title">标签分组</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <Popover position="bottom"
                     :caret="false"
                     :blockContent="true"
                     ref="popoverVm">
              <template slot='trigger'>
                <div class="form-field-value input-control right-addon">
                  <input class="form-field-value" placeholder="请选择要移至的标签分组" type="text" v-model.trim="selectedTagGroupName">
                  <div class="addon">
                    <i class="slp-caret-down"></i>
                  </div>
                </div>
              </template>
              <div class="list" slot='content' v-if="!tagGroups.length">
                <div class="list-item">没有可选的标签分组</div>
              </div>
              <div class="list" slot='content' v-else>
                <template  v-for="item in tagGroups">
                  <div class="list-item" @click="selectTagGroupFunc(item)">
                    <div class='item-wrapper justify-between'>
                      <div class='content node-name text-ellipsis'>
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="item-check" v-if="item == selectedTagGroup">
                        <i class="slp-check"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </Popover>
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  created: function() {
    return Skylark.Libs.Ajax.get(this.doRequestUrl, {
      responseType: 'json',
      success: (data) => {
        return this.tagGroups = _.reject(data, (item) => {
          return item.id === this.rejectTagGroup.id;
        });
      }
    });
  },
  computed: {
    selectedTagGroupName: function() {
      var ref;
      return (ref = this.selectedTagGroup) != null ? ref.name : void 0;
    }
  },
  methods: {
    ensureClicked: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.tagModalRef.open();
        return;
      }
      return this.callback(this.selectedTagGroup.id);
    },
    selectTagGroupFunc: function(item) {
      if (item === this.selectedTagGroup) {
        this.selectedTagGroup = null;
      } else {
        this.selectedTagGroup = item;
      }
      return this.$refs.popoverVm.togglePopover();
    },
    _validate: function() {
      var ref;
      return this.valid = Boolean((ref = this.selectedTagGroup) != null ? ref.id : void 0);
    }
  }
});
